export default {"src":"/_next/static/media/bell-icon.09a1f9cb.svg","height":20,"width":18,"blurWidth":0,"blurHeight":0};